import Vue from 'vue';
import CONST from '../../const';

const HIDE_PRICE_STATUSES = new Set([
  String(CONST.BUDGET_STATUS.BUDGET_INCOMPLETE),
  String(CONST.BUDGET_STATUS.BUDGETED),
]);

const SHOW_PRICE_STATUSES = new Set([
  String(CONST.BUDGET_STATUS.BUDGET_TO_VALIDATE),
  String(CONST.BUDGET_STATUS.BUDGET_ACCEPTED),
  String(CONST.BUDGET_STATUS.BUDGET_PARTIALLY_ACCEPTED),
  String(CONST.BUDGET_STATUS.BUDGET_REJECTED),
  String(CONST.BUDGET_STATUS.ORDER_BY_BUDGET),
]);

export default {
  getOrder(orderId) {
    return Vue.prototype.axios
      .get(`order/${orderId}`)
      .then((res) => {
        const response = res.data;

        if (!response.success) throw new Error(`[${response.errorCode}] ${response.errorDescription}`);

        return response;
      })
      .catch((error) => {
        throw error;
      });
  },
  getOrderDetail(orderId) {
    return Vue.prototype.axios
      .get('getQuotationsAds', {
        params: {
          // dealerId: 1,
          // dealerId: Vue.prototype.$session.get("dealerIdExt"),
          dealerId: Vue.prototype.$session.get('dealerId'),
          orderId,
          userId: 3,
        },
      })
      .then((res) => {
        const respuesta = res.data;

        if (!respuesta.success) throw new Error(`[${respuesta.errorCode}] ${respuesta.errorDescription}`);

        return respuesta;
      })
      .catch((error) => {
        throw error;
      });
  },
  getOrderStatus() {
    return Vue.prototype.axios
      .get('status-order', {
        params: {
          orderId: Vue.prototype.$session.get('orderIdDMS'),
          email: Vue.prototype.$session.get('email'),
          // dealerId: Vue.prototype.$session.get("dealerIdExt"),
          dealerId: Vue.prototype.$session.get('dealerId'),
        },
      })
      .then((res) => {
        const response = res.data;
        const items = Array.isArray(response.data) ? response.data : [];
        const lastWithQuotationStatus = [...items]
          .reverse()
          .find((item) => item && item.orderQuotationStatus != null);

        const status = String(lastWithQuotationStatus?.orderQuotationStatus ?? '');

        if (HIDE_PRICE_STATUSES.has(status)) {
          Vue.prototype.$session.set('showPrice', CONST.SHOW_PRICE_HIDDEN);
        } else if (SHOW_PRICE_STATUSES.has(status)) {
          Vue.prototype.$session.set('showPrice', CONST.SHOW_PRICE_VISIBLE);
        }

        const orders = Vue.prototype.$session.get('orders');
        const invoiceOrder = response.data.filter((order) => order.orderEstatus === 113
          && order.orderIdDMS === orders[0].orderIdDMS);
        const showInvoice = invoiceOrder.length > 0;
        Vue.prototype.$session.set('showInvoice', showInvoice);

        if (!response.success) throw new Error(`[${response.errorCode}] ${response.errorDescription}`);

        return response;
      })
      .catch((error) => {
        throw error;
      });
  },
  getReceptionPdf(orderId) {
    return Vue.prototype.axios
      .get('getReceptionPdf', {
        params: {
          orderId,
          // dealerId: 1
          dealerId: Vue.prototype.$session.get('dealerId'),
        },
      })
      .then((res) => {
        const responseData = res.data;

        if (!responseData.success) throw new Error(`[${responseData.errorCode}] ${responseData.errorDescription}`);

        return responseData;
      })
      .catch((error) => {
        throw error;
      });
  },
  getOrderWork(orderActivityId) {
    return Vue.prototype.axios
      .get('getquotationbyactivity', {
        params: {
          orderActivityId,
          // dealerId: Vue.prototype.$session.get("dealerIdExt"),
          dealerId: Vue.prototype.$session.get('dealerId'),
        },
      })
      .then((res) => {
        const responseD = res.data;

        if (!responseD.success) throw new Error(`[${responseD.errorCode}] ${responseD.errorDescription}`);

        return responseD;
      })
      .catch((error) => {
        throw error;
      });
  },
  getEvidence(orderActivityId) {
    return Vue.prototype.axios
      .get('getActivityEvidence', {
        params: {
          activityId: orderActivityId,
          // dealerId: Vue.prototype.$session.get("dealerIdExt"),
          dealerId: Vue.prototype.$session.get('dealerId'),
        },
      })
      .then((res) => {
        const responseEvidence = res.data;

        if (!responseEvidence.success) throw new Error(`[${responseEvidence.errorCode}] ${responseEvidence.errorDescription}`);

        return responseEvidence;
      })
      .catch((error) => {
        throw error;
      });
  },
  getActivitiesInPackage(packId) {
    return Vue.prototype.axios
      .get('getactivitiesbypacks', {
        params: {
          packId,
          dealerId: Vue.prototype.$session.get('dealerId'),
        },
      })
      .then((res) => {
        const responseActivities = res.data;

        if (!responseActivities.success) throw new Error(`[${responseActivities.errorCode}] ${responseActivities.errorDescription}`);

        return responseActivities;
      })
      .catch((error) => {
        throw error;
      });
  },
};
